import { Flex, RouterTabs } from "@inmagik/magik-ui"
import classNames from "classnames"
import { Children, CSSProperties, ReactNode } from "react"

type ScrollLayoutProps = {
  children: React.ReactNode
  hasBottomFixed?: boolean
}

export function ScrollLayout({ children, hasBottomFixed }: ScrollLayoutProps) {
  return (
    <Flex
      direction="column"
      justifyContent="start"
      alignItems="stretch"
      className="h-100"
      style={{ paddingBottom: hasBottomFixed ? 58 : 0 }}
    >
      {children}
    </Flex>
  )
}

type ScrollLayoutTabsProps = {
  initialTab?: string
  onTabChange?: (tab: string) => void
  children?: React.ReactNode
  className?: string
  style?: CSSProperties
}

function ScrollLayoutTabs({ children, className, ...props }: ScrollLayoutTabsProps) {
  return (
    <RouterTabs
      {...props}
      className={classNames("d-flex flex-column justify-content-start align-items-stretch flex-1", className)}
    >
      {Children.toArray(children)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map((child: any, index:number) => {
          const { className, style, children, ...props } = child.props
          return (
            <RouterTabs.Tab
              key={index}
              className={classNames("flex-1", className)}
              style={{
                ...style,
                position: "relative",
              }}
              {...props}
            >
              <div style={{ position: "absolute", top: 0, right: 0, left: 0, bottom: 0, overflowY: "auto" }}>
                {children}
              </div>
            </RouterTabs.Tab>
          )
        })}
    </RouterTabs>
  )
}

type ScrollLayoutTabProps = {
  label: ReactNode
  id: string
  children: ReactNode
  disabled?: boolean
  className?: string
  style?: CSSProperties
}

function ScrollLayoutTab({ children }: ScrollLayoutTabProps) {
  return <>{children}</>
}

type ScrollLayoutScrollProps = {
  children?: React.ReactNode
  className?: string
  style?: CSSProperties
}

function ScrollLayoutScroll({ children, className, ...props }: ScrollLayoutScrollProps) {
  return (
    <div
      {...props}
      className={classNames(
        "d-flex flex-column justify-content-start align-items-stretch flex-1 position-relative",
        className
      )}
    >
      <div style={{ position: "absolute", top: 0, right: 0, left: 0, bottom: 0, overflowY: "auto" }}>{children}</div>
    </div>
  )
}

ScrollLayout.Scroll = ScrollLayoutScroll
ScrollLayout.Tabs = ScrollLayoutTabs
ScrollLayout.Tab = ScrollLayoutTab
